<template>
  <div class="container py-5">

    <div class="buttons">
      <router-link 
        class="button is-primary"
        :to="{ name: 'StorageMaker' }">
        Create a New Storage
      </router-link>

      <v-fade-transition mode="out-in">
        <button
          v-if="selected.length > 0" 
          class="button" @click="launchConfirmDelete()">
          <span class="icon is-medium">
            <i class="fas fa-trash has-text-danger"></i>
          </span>
          <span>
            Delete {{ selected.length }} Selected Storages
          </span>
        </button>
      </v-fade-transition>
    </div>

    <article 
      v-if="!loading && storages.length == 0" 
      class="message is-info is-fullwidth mt-3">
      <div class="message-body">
        There are no storages.
      </div>
    </article>

    <table 
      v-if="loading || storages.length > 0"
      class="table is-hoverable is-clickable is-fullwidth">

      <thead>
        <tr>
          <th>
            <v-checkbox 
              :value="allSelected"
              @input="toggleAllSelected"/>
          </th>
          <th 
            v-for="(header, headerIndex) in headers" 
            :key="headerIndex">
            {{ header.label }}
          </th>
          <th></th>
        </tr>
        <tr v-if="loading">
          <th :colspan="headers.length + 2" class="py-0 px-0 is-naked">
            <v-progress class="is-fullwidth" v-model="loading"/>
          </th>
        </tr>
      </thead>

      <tbody v-if="storages.length > 0">
        <tr 
          class="pointer v-centered"
          v-for="storage in storages"
          :key="storage.id"
          @click="viewStorage(storage)">
          <td @click.stop="">
            <v-checkbox 
              :value="selected.includes(storage.id)"
              @input="toggleSelected(storage.id)"/>
          </td>
          <td>{{ storage.storage_code }}</td>
          <td>{{ storage.storage_name }}</td>
          <td>{{ storage.storage_type.storage_type_name }}</td>
          <td>
            <template v-if="storage.warehouse_location">
              <div class="is-size-7">
                {{ storage.warehouse_location.warehouse.warehouse_code }}
              </div>
              <div>
                {{ storage.warehouse_location.warehouse.warehouse_name }}
              </div>
            </template>
          </td>
          <td>
            <template v-if="storage.warehouse_location">
              <div class="is-size-7">
                {{ storage.warehouse_location.location_code }}
              </div>
              <div>
                {{ storage.warehouse_location.location_code }}
              </div>
            </template>
          </td>
          <td>{{ storage.storage_units.length }}</td>
          <td>{{ format(parse(storage.created_on)) }}</td>
          <td>{{ storage.created_user.display_name }}</td>
          <td>
            <div class="buttons buttons-right">
              <button
                @click.stop="launchConfirmDelete(storage.id)" 
                class="button is-small">
                <span class="icon">
                  <i class="fas fa-trash has-text-grey"></i>
                </span>
                <span>Delete</span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>

    </table>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

    <v-confirm-modal 
      v-model="confirmDelete.state"
      :title="confirmDelete.title"
      :message="confirmDelete.message"
      :type="confirmDelete.type"
      @confirm="deleteConfirmedCb ? deleteConfirmedCb() : null"
      @cancel="confirmDelete.state = false"/>

  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import VConfirmModal from '@/components/base/VConfirmModal'
import VCheckbox from '@/components/base/VCheckbox'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import VProgress from '@/components/base/VProgress'

import { mapState, mapActions, mapMutations } from 'vuex'
import { parseISO, format } from 'date-fns'

export default {
  components: { VConfirmModal, VPagination, VCheckbox, VFadeTransition, VProgress },
  data() {
    return {
      headers: [
        { label: 'Storage Code' },
        { label: 'Storage Name' },
        { label: 'Storage Type' },
        { label: 'Warehouse' },
        { label: 'Warehouse Space' },
        { label: '# of Items' },
        { label: 'Created On'},
        { label: 'Created By' }
      ],
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this storage?',
        type: 'danger'
      },
      deleteConfirmedCb: null,
      parse: (d) => {
        return d ? parseISO(d) : null
      },
      format: (d) => {
        return d ? format(d, 'yyyy-MM-dd H:mm:ss') : null
      }
    }
  },
  computed: {
    ...mapState("storages", [
      "storages", "pagination", "loading", "allSelected", "selected"
    ])
  },
  watch: {
    'pagination.page'(page) {
      this.getStorages({ page: page });
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("storages", ["getStorages", "deleteStorage", "toggleAllSelected"]),
    ...mapMutations("storages", ["toggleSelected", "changePage"]),
    initialize() {
      this.getStorages();
    },
    viewStorage(storage) {
      this.$router.push({ 
        name: 'StorageViewer', 
        params: { 
          storageId: storage.id,
          storage: storage
        }
      })
    },
    launchConfirmDelete(id) {
      if (id) {
        this.deleteConfirmedCb = () => {
          this.deleteStorage(id).then(
            () => this.confirmDelete.state = false
          );
        };
      } else {
        this.deleteConfirmedCb = () => {
          this.selected.forEach(id => {
            this.deleteStorage(id);
          });
          this.confirmDelete.state = false;
        };
      }
      this.confirmDelete.state = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>